import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import ReactSelect, { components } from 'react-select';
import FieldErrorMessage from '../FieldErrorMessage';
import HintWarranty from "../HintWarranty";

const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <div className='dropdown-indicator'></div>
      </components.DropdownIndicator>
    );
};

const SelectWarranty = (props ) => {
    const { control, register, unregister } = useFormContext();
    const { defaultValue,
        label,
        name,
        options,
        isRequired,
        isSearchable,
        hint = '',
        rules,
        reset = null,
        indexSection = 0,
        getIndexChangeSelect = null,
        productStyleValue = null,
        idForm = ''} = props;
    const customStylesSelect = {
        control: (provided, state) => ({
            ...provided,
            width: '100%',
            display: 'flex',
            padding: '6px 10px 3px',
            backgroundColor: '#fff',
            textOverflow: 'ellipsis',
            borderRadius: '0',
            color: '#474c4f',
            fontSize: '16px',
            fontWeight: '400',
            lineHeight: '24px',
            outline: 'none',
            border: '2px solid #eef3f5',
            minHeight: '45px',
            boxShadow: state.isFocused ? '0 0 8px rgba(0, 0, 0, 0.3)' : 'none',
            '&:hover': {
                border: '2px solid #eef3f5',
            },
            "@media only screen and (min-width: 768px)": {
                fontSize: '23px',
                lineHeight: '36px',
                minHeight: '57px',
            },
        }),
        valueContainer: () => ({
            padding: 0,
            display: 'flex',
            alignItems: 'center',
            flex:  1,
            flexWrap: 'wrap',
            position: 'relative',
            overflow: 'hidden'
        }),
        singleValue: () => ({
            color: '#474c4f',
            margin: 0,
            maxWidth: 'calc(100% - 8px)',
            overflow: 'hidden',
            position: 'absolute',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            top: '50%',
            transform: 'translateY(-50%)',
            boxSizing: 'border-box',
        }),
        indicatorSeparator: (provided) => ({
            display: 'none'
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            width: 33,
            height: 30,
            padding: 0,
            alignItems: 'center',
            justifyContent: 'center',
        }),
        placeholder: (provided) => ({
            ...provided,
            margin: 0,
            maxWidth: 'calc(100% - 8px)',
            overflow: 'hidden',
            position: 'absolute',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            top: '50%',
            transform: 'translateY(-50%)',
            boxSizing: 'border-box',
        })
    }

    useEffect( () => {
        return () => {
            unregister( name )
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );

    return (
        <div className={`form-item form-item--select`}>
            <label htmlFor={name}>
                {label}
                {isRequired && <span className="required">*</span>}
                {hint && <HintWarranty hint={hint}/>}
            </label>
            <Controller
                name={name}
                control={control}
                rules={rules}
                defaultValue={defaultValue}
                render={({ onChange, value, name, ref }) => (
                    <ReactSelect
                        placeholder="- Select -"
                        name={name}
                        refs={register(rules)}
                        inputRef={ref}
                        defaultValue={defaultValue}
                        components={{ DropdownIndicator }}
                        styles={customStylesSelect}
                        className="form-item--select-container-warranty"
                        options={options}
                        value={options.find(c => c.value === value)}
                        onChange={val => {
                            productStyleValue && productStyleValue(val.value + indexSection)
                            getIndexChangeSelect && getIndexChangeSelect(indexSection);
                            onChange(val.value)
                        }}
                        isSearchable={isSearchable}
                        classNamePrefix="form-item--select-container-warranty"
                        ref={reset}
                    />
                )}
            />
            <FieldErrorMessage name={name}/>
        </div>
    );
};

SelectWarranty.propTypes = {
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    options: PropTypes.arrayOf( PropTypes.object ).isRequired,
    isRequired: PropTypes.bool,
    isSearchable: PropTypes.bool,
    // @todo: How to make it required conditionaly?
    rules: PropTypes.objectOf( PropTypes.any ),
};

SelectWarranty.defaultProps = {
    isRequired: true,
    isSearchable: false,
    rules: null,
    defaultValue: "",
};

export default SelectWarranty;
